export enum CompanyAgreementTypeEnum {
  SIGNATURE = 'signature',
  PAYMENT = 'payment',
}
